import { jsx as _jsx } from "react/jsx-runtime";
import { isPayLaterProduct } from '../../../../helpers';
import PaymentMethodTypeSelector from './index';
const PaymentMethodTypeSelectorWrapper = ({ errorMessage, featureFlags, paymentMethodType, productType, handlePaymentMethodTypeChange }) => {
    if (isPayLaterProduct(productType)) {
        return (_jsx(PaymentMethodTypeSelector, { errorMessage: errorMessage, featureFlags: featureFlags, handlePaymentMethodTypeChange: handlePaymentMethodTypeChange, paymentMethodType: paymentMethodType, productType: productType }));
    }
    if (featureFlags.isSavingCheckingEnabled) {
        return (_jsx(PaymentMethodTypeSelector, { errorMessage: errorMessage, featureFlags: featureFlags, handlePaymentMethodTypeChange: handlePaymentMethodTypeChange, paymentMethodType: paymentMethodType, productType: productType }));
    }
    return null;
};
export default PaymentMethodTypeSelectorWrapper;
